import type { ReactNode } from "react";
import { Collapse, Group, Loader, Text } from "@mantine/core";
import { IconChevronDown, IconChevronUp, type Icon } from "@tabler/icons-react";

type CollapsibleHistoryCardProps = {
  icon: Icon;
  label: string;
  count: number;
  isLoading?: boolean;
  open: boolean;
  onToggle: () => void;
  trailing?: ReactNode;
  children: ReactNode;
};

export function CollapsibleHistoryCard({
  icon: HeaderIcon,
  label,
  count,
  isLoading = false,
  open,
  onToggle,
  trailing,
  children,
}: CollapsibleHistoryCardProps) {
  return (
    <>
      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <div
          className="flex cursor-pointer items-center justify-between"
          onClick={onToggle}
        >
          <Group gap="xs">
            <HeaderIcon size={20} className="text-brand" />
            {isLoading ? (
              <Loader size="sm" />
            ) : (
              <Text className="text-base font-semibold text-brand">
                {label} ({count})
              </Text>
            )}
          </Group>
          <Group gap="xs" align="center">
            {trailing ? (
              <div onClick={(event) => event.stopPropagation()}>{trailing}</div>
            ) : null}
            {open ? (
              <IconChevronUp size={20} className="text-brand" />
            ) : (
              <IconChevronDown size={20} className="text-brand" />
            )}
          </Group>
        </div>
      </div>

      <Collapse in={open} transitionDuration={200}>
        <div className="mt-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          {children}
        </div>
      </Collapse>
    </>
  );
}
